/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * A React component for more vertical icon.
 *
 * @author Ramani Govindaraju
 */
const MoreVertIcon = props => (
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <path
      d="M9 5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2
      2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    />
  </SvgIcon>
);

export default MoreVertIcon;



// WEBPACK FOOTER //
// ./src/js/icons/MoreVertIcon.jsx